<template>
  <div>
    <NavBarDSO />
    <div class="buy-wrapper">

        <h1 class="table-headline"><strong>Consumption</strong></h1>
<!-- 
        <div class="balance-flex">
            <div class="balance1 page-bubble">
                <div class="bold">Percentage of Energy Saving</div>
                <div class="balance" id="balance"></div>
                <div class="summary-middle-table page-bubble">
                    <table class="results-table">
                        <thead>
                        </thead>
                        <tbody>
                            <tr>
                                <th>EAN Number</th>
                                <th>Month</th>
                                <th>Category</th>
                                <th>Energy Saving (%)</th>
                            </tr>
                            <tr :class="{ active: index == currentEnergyDataIndex }"
                                v-for="(energyData, index) in energyDatas"
                                :key="index"
                                @click="setActiveEnergyData(energyData, index)">
                                <td>{{ energyData.EAN }}</td>
                                <td>{{ energyData.Month }}</td>
                                <td>{{ energyData.Category }}</td>
                                <td>{{ energyData.EnergySaving }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="summary-graph page-bubble">
                <PieChart />
            </div>
        </div>

        <div class="balance-flex">
            <div class="balance1 page-bubble">
                <div class="bold">Current Energy Consumptions</div>
                <div class="balance" id="balance_eth">kW</div>
                <div class="summary-middle-table page-bubble">
                    <table class="results-table">
                        <tbody>
                            <tr>
                                <th>EAN Number</th>
                                <th>Month</th>
                                <th>Energy Consumption</th>
                            </tr>
                            <tr :class="{ active: index == currentAvgConsumptionIndex }"
                                v-for="(avgConsumption, index) in avgConsumptions"
                                :key="index"
                                @click="setActiveAvgConsumption(avgConsumption, index)">
                                <td>{{ avgConsumption.EAN }}</td>
                                <td>{{ avgConsumption.Month }}</td>
                                <td>{{ avgConsumption.Consumption }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="summary-graph page-bubble">
                <SummaryChart />
            </div>
        </div>

        <div class="balance-flex">
            <div class="balance1 page-bubble">
                <div class="bold">Current Peak Consumptions</div>
                <div class="balance" id="balance_eth">kW</div>
                <div class="summary-middle-table page-bubble">
                    <table class="results-table">
                        <tbody>
                            <tr>
                                <th>EAN Number</th>
                                <th>Year</th>
                                <th>Peak Consumption</th>
                            </tr>
                            <tr :class="{ active: index == currentAvgPeakIndex }"
                                v-for="(avgPeak, index) in avgPeaks"
                                :key="index"
                                @click="setActiveAvgPeak(avgPeak, index)">
                                <td>{{ avgPeak.EAN }}</td>
                                <td>{{ avgPeak.Year }}</td>
                                <td>{{ avgPeak.Peak }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="summary-graph page-bubble">
                <BarChart />
            </div>
        </div>
 -->

        <div class="balance-flex">
            <div class="balance1 page-bubble">
                <div class="bold">Hourly Energy Consumptions</div>
                <div class="balance" id="balance_eth">kWh</div>
                <div class="summary-middle-table page-bubble">
                    <input type="date" id="date" name="date" v-model="defaultDate" @change="changeDate($event)">
                    <table class="results-table">
                        <tbody>
                            <tr>
                                <th>Date</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Energy Consumption (kWh)</th>
                            </tr>
                            <tr :class="{ active: index == currentConsumptionIndex }"
                                v-for="(consumption, index) in consumptions"
                                :key="index"
                                @click="setActiveAvgConsumption(consumption, index)">
                                <td>{{ consumption.date }}</td>
                                <td>{{ consumption.from }}</td>
                                <td>{{ consumption.to }}</td>
                                <td>{{ consumption.consumption }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="summary-graph page-bubble">
                <ConsumptionChart />
            </div>
        </div>
        
        <div class="summary-middle">
            
            
        </div>
    </div>

<p></p>
      <div class="page-bubble transactions" style="display:none" id="trans_1">
        <h3 class="table-headline">User Transaction history</h3>
        <table id="transactions">
          <thead>
            <tr>
<th>Event</th>
<th>From</th>
<th>Asset Name</th>
<th>Capacity</th>
<th>Price</th>
<th>Company Type</th>
<th>City</th>
<th>Date</th>
            </tr>
          </thead>
        </table>
      </div>
	<div class="page-bubble transactions" style="display:none" id="trans_2">
        <h3 class="table-headline">Offer Transaction history</h3>
        <table id="order_transactions">
          <thead>
            <tr>
<th>Event</th>
<th>From</th>
<th>Asset Name</th>
<th>Capacity</th>
<th>Price</th>
<th>Company Type</th>
<th>City</th>
<th>Date</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  
</template>

<script>
import NavBarDSO from "../components/Common/NavBarDSO";
import ConsumptionChart from "../components/Charts/ConsumptionChart";

import moment from 'moment';

const consumptionsData = require("../maps/data/eflex_consumption_demo_data");
//import BarChart from "../components/Charts/BarChart";
//import PieChart from "../components/Charts/PieChart";
//import KbcDataService from "../services/KbcDataService";

//const axios = require('axios');

export default {

    components: { NavBarDSO, ConsumptionChart },

    data() {
        return {
            //selected: null,

            defaultDate: '2020-11-01',

            consumptions: [],
            currentConsumption: null,
            currentConsumptionIndex: -1,

/* 
            avgConsumptions: [],
            currentConsumption: null,
            currentConsumptionIndex: -1,
            avgPeaks: [],
            currentPeak: null,
            currentPeakIndex: -1,

            energyDatas: [],
            currentEnergyData: null,
            currentEnergyDataIndex: -1,
 */

            // to get more default config information see default config page 
            popupDefaultConfig: {
                title: 'ciao-vue-popup',
                apply: {
                    extraClass: 'btn btn-sm btn-info',
                },
                prompt: {
                    inputCustomClass: 'form-control form-control-sm',
                },
            }
        }
    },

    methods: {

        selectAll() {
            let boxes = document.querySelectorAll("input");
            for (let box of boxes) {
                box.checked = true;
            }
        },

        setActiveConsumption(consumption, index) {
            this.currentConsumption = consumption;
            this.currentConsumptionIndex = index;
        },

        format_date(value){
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY')
            }
        },

        getConsumptions(date) {

            //console.log("HERE... consumptions data: " + consumptionsData.toString());

            this.consumptions = [];
      
            for (var i = 0; i < consumptionsData.length; i++) {
                if (consumptionsData[i].date == date) {
                    this.consumptions.push(consumptionsData[i]);
                }
            }
        
            console.log("HERE... consumptions: " + this.consumptions.toString());

        },

        changeDate(event) {
            this.$emit("date", event.target.value);
            console.log("HERE... change date: " + this.format_date(event.target.value));
            this.getConsumptions(this.format_date(event.target.value));
            this.$root.$emit("getConsumptions", this.format_date(event.target.value));
            //this.ConsumptionChart.getConsumptions(this.format_date(event.target.value));
            //ConsumptionChart.initChart(this.format_date(event.target.value));
        },
/* 
        retrieveEnergyData() {
            axios({
                method: 'get',
                url: 'http://127.0.0.1:5000/',
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'json'
            })
            .then((response) => {
                console.log("HERE type of response data: " +typeof response.data );
                console.log("HERE... load energyData sucessfull: " + response.data);
                var tempData = JSON.stringify(response.data);
                console.log("HERE type of temp data: " +typeof tempData );
                this.energyDatas = JSON.parse(tempData);
                console.log("HERE type of energy data: " +typeof this.energyDatas );
                console.log("HERE... energyData: " + this.energyDatas[0]);
            })
            .catch((e) => {
                console.log("HERE... load energyData error: " + e);
            });
        },

        setActiveEnergyData(energyData, index) {
            this.energyData = energyData;
            this.currentEnergyDataIndex = index;
        },
        
        retrieveAvgConsumptions() {
            KbcDataService.getAvgConsumptions()
            .then((response) => {
                this.avgConsumptions = response.data;
                console.log("HERE... load AvgConsumptions sucessfull: " + response.data);
            })
            .catch((e) => {
                console.log("HERE... load AvgConsumptions error: " + e);
            });
        },

        retrieveAvgPeaks() {
            KbcDataService.getAvgPeaks()
            .then((response) => {
                this.avgPeaks = response.data;
                console.log("HERE... load AvgPeaks sucessfull: " + response.data);
            })
            .catch((e) => {
                console.log("HERE... load AvgPeaks error: " + e);
            });
        },

        setActiveConsumption(consumption, index) {
            this.currentConsumption = consumption;
            this.currentConsumptionIndex = index;
        },

        setActivePeak(peak, index) {
            this.currentPeak = peak;
            this.currentPeakIndex = index;
        }, 
*/
    },
    
    mounted: function () {
        this.$nextTick(function () {
            this.getConsumptions("01/11/2020");
            //this.retrieveEnergyData();
            //this.retrieveAvgConsumptions();
            //this.retrieveAvgPeaks();
            // Code that will run only after the entire view has been rendered
        });
    },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #e6e8f0;
}

.balance-flex {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 30px;
}

.balance1 {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.balance {
  margin: 20px 0;
  font-size: 1.3em;
}

.conversion {
  font-size: .8em;
  color: #999
}

.summary-middle {
  display: flex;
  margin: 60px 0;
}

.summary-graph {
  width: 100%;
  flex: 1;
}

.summary-middle-table {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0;
}

.summary-middle-table table {
  margin: 0;
}

.buy-wrapper table{
  width: 100%;
}

.buy-wrapper th {
  color: #4a4a4a;
  font-size: 12px;
  //text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.buy-wrapper td {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e6e6e6;
}

.buy-wrapper tr:hover {
  background: #f5f8fd;
}

.results-table {
  width: 100%;
  background: #fff;
  margin-bottom: 30px;
  max-height: 220px;
  overflow-x: auto;
  display: block;
}

.transactions {
  width: 100%;
}
</style>